module.exports = __webpack_public_path__ + "static/media/mascote.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app/home/images/mascote.png
// module id = 2721
// module chunks = 0